var _path, _g, _path2, _path3, _path4, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 33,
    viewBox: "0 0 78 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11394_2262)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11394_2262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6468 0.20459H0.940918V32.2046H32.6468V0.20459Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11394_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7939 32.2046C8.03987 32.2046 0.940918 25.0398 0.940918 16.2046C0.940918 7.36939 8.03987 0.20459 16.7939 0.20459C25.5479 0.20459 32.6468 7.36939 32.6468 16.2046C32.6468 25.0398 25.5479 32.2046 16.7939 32.2046Z",
    fill: "url(#paint0_linear_11394_2262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7938 1.57586C8.79028 1.57586 2.29968 8.12668 2.29968 16.2044C2.29968 24.2822 8.79028 30.833 16.7938 30.833C24.7973 30.833 31.2879 24.2822 31.2879 16.2044C31.2879 8.12668 24.7973 1.57586 16.7938 1.57586ZM-0.417969 16.2044C-0.417969 6.6118 7.28932 -1.16699 16.7938 -1.16699C26.2983 -1.16699 34.0056 6.6118 34.0056 16.2044C34.0056 25.7971 26.2983 33.5759 16.7938 33.5759C7.28932 33.5759 -0.417969 25.7971 -0.417969 16.2044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7936 7.25072C19.682 7.25072 20.0245 7.26031 21.1659 7.31471C22.2217 7.36271 22.7955 7.54191 23.176 7.69231C23.6801 7.89071 24.0416 8.12751 24.4189 8.50831C24.7962 8.88911 25.0308 9.25391 25.2274 9.76271C25.3764 10.1467 25.5507 10.7259 25.6015 11.7915C25.6522 12.9435 25.6649 13.2891 25.6649 16.2043C25.6649 19.1195 25.6554 19.4651 25.6015 20.6171C25.5539 21.6827 25.3764 22.2619 25.2274 22.6459C25.0308 23.1547 24.7962 23.5195 24.4189 23.9003C24.0416 24.2811 23.6801 24.5179 23.176 24.7163C22.7955 24.8667 22.2217 25.0427 21.1659 25.0939C20.0245 25.1451 19.682 25.1579 16.7936 25.1579C13.9052 25.1579 13.5628 25.1483 12.4214 25.0939C11.3656 25.0459 10.7917 24.8667 10.4112 24.7163C9.90711 24.5179 9.54566 24.2811 9.16836 23.9003C8.79106 23.5195 8.55644 23.1547 8.35986 22.6459C8.21084 22.2619 8.03642 21.6827 7.98569 20.6171C7.93496 19.4651 7.92232 19.1195 7.92232 16.2043C7.92232 13.2891 7.93179 12.9435 7.98569 11.7915C8.03325 10.7259 8.21084 10.1467 8.35986 9.76271C8.55644 9.25391 8.79106 8.88911 9.16836 8.50831C9.54566 8.12751 9.90711 7.89071 10.4112 7.69231C10.7917 7.54191 11.3656 7.36591 12.4214 7.31471C13.5628 7.26031 13.9052 7.25072 16.7936 7.25072ZM16.7936 5.28271C13.8544 5.28271 13.4867 5.29551 12.3326 5.34991C11.1816 5.40431 10.3954 5.58671 9.70419 5.85871C8.99398 6.13391 8.3884 6.50831 7.78916 7.11631C7.18674 7.72431 6.81896 8.33231 6.53994 9.05231C6.27361 9.74672 6.08972 10.5403 6.03582 11.7051C5.98192 12.8699 5.96924 13.2411 5.96924 16.2075C5.96924 19.1739 5.98192 19.5451 6.03582 20.7099C6.08972 21.8715 6.27044 22.6651 6.53994 23.3627C6.81579 24.0763 7.18674 24.6875 7.78916 25.2923C8.39157 25.9003 8.99398 26.2715 9.70736 26.5531C10.3954 26.8219 11.1816 27.0075 12.3357 27.0619C13.4898 27.1163 13.8577 27.1291 16.7968 27.1291C19.7359 27.1291 20.1037 27.1163 21.2578 27.0619C22.4087 27.0075 23.195 26.8251 23.8862 26.5531C24.5932 26.2747 25.1989 25.9003 25.7981 25.2923C26.4005 24.6843 26.7683 24.0763 27.0473 23.3563C27.3136 22.6619 27.4975 21.8683 27.5514 20.7035C27.6053 19.5387 27.618 19.1675 27.618 16.2011C27.618 13.2347 27.6053 12.8635 27.5514 11.6987C27.4975 10.5371 27.3168 9.74352 27.0473 9.04592C26.7715 8.33231 26.4005 7.72111 25.7981 7.11631C25.1957 6.50831 24.5933 6.13711 23.8799 5.85551C23.1919 5.58671 22.4055 5.40112 21.2514 5.34672C20.1005 5.29551 19.7327 5.28271 16.7936 5.28271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7939 10.5947C13.7248 10.5947 11.2358 13.1067 11.2358 16.2043C11.2358 19.3019 13.7248 21.8139 16.7939 21.8139C19.863 21.8139 22.3519 19.3019 22.3519 16.2043C22.3519 13.1067 19.863 10.5947 16.7939 10.5947ZM16.7939 19.8459C14.8028 19.8459 13.1858 18.2171 13.1858 16.2043C13.1858 14.1915 14.8028 12.5627 16.7939 12.5627C18.785 12.5627 20.402 14.1915 20.402 16.2043C20.402 18.2171 18.785 19.8459 16.7939 19.8459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5709 11.686C23.2888 11.686 23.8709 11.0986 23.8709 10.374C23.8709 9.64939 23.2888 9.06201 22.5709 9.06201C21.853 9.06201 21.271 9.64939 21.271 10.374C21.271 11.0986 21.853 11.686 22.5709 11.686Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.441 1.00439C20.7688 1.55639 18.8646 28.0006 37.0758 31.4044H41.8063C60.0217 27.9974 58.1094 1.55447 39.441 1.00439Z",
    fill: "#1877F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2463 29.5758H41.6357C57.5545 26.4431 55.8066 3.36563 39.4411 2.83383C23.0722 3.3673 21.3306 26.4459 37.2463 29.5758ZM39.441 1.00439C20.7688 1.55639 18.8646 28.0006 37.0758 31.4044H41.8063C60.0217 27.9974 58.1094 1.55447 39.441 1.00439Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8062 20.7179H45.3334L46.0046 16.2975H41.8062V13.4287C41.8062 12.2194 42.3927 11.0405 44.2732 11.0405H46.1822V7.27699C42.094 6.53363 37.1825 6.75986 37.0756 12.9282V16.2975H33.2319V20.7179H37.0756V31.4047H41.8062V20.7179Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11394_2262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 0,
    width: 32,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9407 0.20459H46.2349V32.2046H77.9407V0.20459Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11394_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0878 32.2046C70.8432 32.2046 77.9407 25.0412 77.9407 16.2046C77.9407 7.36802 70.8432 0.20459 62.0878 0.20459C53.3325 0.20459 46.2349 7.36802 46.2349 16.2046C46.2349 25.0412 53.3325 32.2046 62.0878 32.2046Z",
    fill: "#F20000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0878 30.376C69.8426 30.376 76.129 24.0312 76.129 16.2046C76.129 8.37794 69.8426 2.03316 62.0878 2.03316C54.333 2.03316 48.0466 8.37794 48.0466 16.2046C48.0466 24.0312 54.333 30.376 62.0878 30.376ZM77.9407 16.2046C77.9407 25.0412 70.8432 32.2046 62.0878 32.2046C53.3325 32.2046 46.2349 25.0412 46.2349 16.2046C46.2349 7.36802 53.3325 0.20459 62.0878 0.20459C70.8432 0.20459 77.9407 7.36802 77.9407 16.2046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6427 12.3563C69.3256 11.3626 68.2766 10.7752 67.3023 10.6384C63.8301 10.2657 60.3284 10.2657 56.8561 10.6384C55.8905 10.7752 54.841 11.371 54.5239 12.3563C54.0298 14.8983 54.0298 17.5131 54.5239 20.0552C54.8496 21.0468 55.8986 21.6363 56.8729 21.7731C60.3451 22.1436 63.8468 22.1436 67.3191 21.7731C68.2847 21.6363 69.3342 21.0384 69.6513 20.0552C70.1427 17.5126 70.14 14.8978 69.6427 12.3563ZM60.1916 19.2699V13.1394L65.1373 16.2047C63.4704 17.2384 61.8521 18.2447 60.1916 19.2699Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11394_2262",
    x1: 5.58415,
    y1: 27.5183,
    x2: 28.2106,
    y2: 5.09982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11394_2262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 32,
    fill: "white",
    transform: "translate(0.940918 0.20459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.dc9bee1bf25d7e3af2b181fd02d52103.svg";
export { ForwardRef as ReactComponent };